import { render, staticRenderFns } from "./servieItemHeader.vue?vue&type=template&id=253cdad2&"
import script from "./servieItemHeader.vue?vue&type=script&lang=ts&"
export * from "./servieItemHeader.vue?vue&type=script&lang=ts&"
import style0 from "./servieItemHeader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports